import { format } from "date-fns";
import { DataTable, DataTableColumnDef } from "@/components/molecules";
import { useProfile } from "@/hooks";
import { BookingPaymentLedgerLog } from "@/redux/slices/booking/types";
import { formatCurrency } from "@/utils";
import { useSelectedBooking } from "../../../hooks/useSelectedBooking";
import { getPaymentCategory, getLedgerPaymentType, getLedgerFromToText } from "../helpers";
import { BookingPaymentLedgerData } from "../types";

const columns: DataTableColumnDef<BookingPaymentLedgerData>[] = [
  {
    header: "Payment Category",
    accessorKey: "paymentCategory",
    size: 120,
    enableSorting: false,
  },
  {
    header: "Date",
    accessorKey: "date",
    size: 100,
    enableSorting: false,
  },
  {
    header: "Type",
    accessorKey: "type",
    enableSorting: false,
    size: 200,
  },
  {
    header: "From → To",
    accessorKey: "fromTo",
    enableSorting: false,
    size: 180,
  },
  {
    header: "Amount",
    accessorKey: "amount",
    enableSorting: false,
  },
  // {
  //   header: "Action",
  //   size: 100,
  //   cell: (props) => props.row.original.actions,
  // },
];

export const PaymentLedgerTable = ({ items }: { items: BookingPaymentLedgerLog[] }) => {
  const { dateFormat } = useProfile();
  const {
    cost: { currency },
  } = useSelectedBooking();

  const data: BookingPaymentLedgerData[] = [...items]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .flatMap((log) => {
      const paymentCategory = getPaymentCategory(log.type);
      const fromToText = getLedgerFromToText(log.type, log.description, log.category);
      const formattedType = getLedgerPaymentType(log.type, log.description, log.category);

      const amount = Math.abs(log.amount);
      const formattedAmount = formatCurrency(amount, 2, currency);
      const displayAmount = paymentCategory === "Paid" ? `-${formattedAmount}` : formattedAmount;

      const mainRecord = {
        id: log.id,
        paymentCategory,
        date: format(new Date(log.createdAt), dateFormat),
        type: formattedType,
        fromTo: fromToText,
        amount: displayAmount,
        // actions: <PaymentLedgerTableActions log={log} />,
      };

      if (log.fees > 0) {
        const feeAmount = log.fees;
        const formattedFeeAmount = formatCurrency(feeAmount, 2, currency);
        const displayFeeAmount = `-${formattedFeeAmount}`;

        const feeRecord = {
          id: `${log.id}-fee`,
          paymentCategory: "Paid" as const,
          date: format(new Date(log.createdAt), dateFormat),
          type: log.category === "client" ? "CC Processing Fee" : "Stripe Bank Sweep Fee",
          fromTo: "Stripe → Stripe",
          amount: displayFeeAmount,
          // actions: <span></span>,
        };

        return [mainRecord, feeRecord];
      }

      return [mainRecord];
    });

  return <DataTable data={data} columns={columns} className="mt-5 w-full overflow-x-auto [&_table]:table-auto" />;
};

// const PaymentLedgerTableActions = ({ log }: { log: BookingPaymentLedgerLog }) => {
//   const dispatch = useDispatch();

//   return (
//     <div className="contents">
//       {log.isReturnable && (
//         <Button
//           onClick={() => dispatch(setPaymentAction({ action: "return-funds", log }))}
//           variant="custom"
//           startIcon="Refresh2"
//           className="!p-0 text-primary [&>.typography]:text-sm [&>.typography]:font-medium"
//         >
//           Return
//         </Button>
//       )}
//       {log.isDisburseable && (
//         <Button
//           onClick={() => dispatch(setPaymentAction({ action: "disburse-funds", log }))}
//           variant="custom"
//           startIcon="Export"
//           className="!p-0 text-primary [&>.typography]:text-sm [&>.typography]:font-medium"
//         >
//           Disburse
//         </Button>
//       )}
//     </div>
//   );
// };
